import { Form, useFormikContext } from 'formik';
import { MapSessionFormFields, SectionContainerContent, YesNoRadioControl } from '../../components';
import { ClinicalNotesFormType } from '../../types';
import { useSectionStyles } from '../styles';
import clsx from 'clsx';
import { useClinicalNotesContext } from '../../clinical-notes.context';
import { dynamicFormVisibilityMapping } from '../../helpers';
import { useL10n } from '@uplift/hooks';
import { useUserDisplayNameQuery } from '@uplift/queries';

export const RiskAssessment: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useSectionStyles();
  const formik = useFormikContext<ClinicalNotesFormType>();
  const { state: { appointment: { patient: { id: patientId, firstName } } } } = useClinicalNotesContext();
  const { data: patientProfile } = useUserDisplayNameQuery(patientId);
  const patientName = patientProfile?.first || firstName;

  const showForm = formik.values.riskAssessmentDenyYesNo === dynamicFormVisibilityMapping.riskAssessment.visibleOnYesNoValue;

  return (
    <>
      <SectionContainerContent>
        <YesNoRadioControl
          baseName="riskAssessmentDeny"
          label={l10n.clinicalNotes.denyRisk(patientName)}
        />
      </SectionContainerContent>
      {showForm && (
        <SectionContainerContent className={classes.greyBackground}>
          <Form className={clsx([ classes.formGroup, classes.gap2 ])}>
            <MapSessionFormFields namespace="riskAssessment" />
          </Form>
        </SectionContainerContent>
      )}
    </>
  );
};
